import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const HtmlTooltip = styled(
  ({ className, isArabic, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
  {
    shouldForwardProp: (prop) => prop !== 'isArabic',
  }
)(({ theme, isArabic }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    borderRadius: '10px',
    padding: '12px',
    fontFamily: isArabic ? 'AlmaraiRegular' : 'AvenirRegular',
    textAlign: isArabic ? 'right' : 'left',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#FFFFFF',
    marginLeft: '5px',
  },
}));

const CustomToolTip = ({ title, children, className, isArabic = false }) => {
  return (
    <HtmlTooltip
      title={title}
      arrow
      placement="top-start"
      className={className}
      isArabic={isArabic}
    >
      {children}
    </HtmlTooltip>
  );
};

export default CustomToolTip;